import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { httpService } from "@services/http.service";

import {
  IGetExerciseEntrypointApiParams,
  IGetExerciseEntrypointApiResponse,
} from "./exercise-entrypoint.types";

export const exerciseEntrypointApi = createApi({
  reducerPath: "exerciseEntrypointApi",
  baseQuery: httpService({
    baseUrl: `/api/v1`,
  }),
  tagTypes: ["exerciseEntrypointData"],
  endpoints: (build) => ({
    getExerciseEntrypoint: build.query<
      IGetExerciseEntrypointApiResponse,
      IGetExerciseEntrypointApiParams
    >({
      query: ({ exerciseId }) => ({
        url: `/user/info/exercise-entrypoint/${exerciseId}/`,
        method: "get",
      }),
      providesTags: () => ["exerciseEntrypointData"],
    }),
  }),
});

export const {
  useGetExerciseEntrypointQuery,
  useLazyGetExerciseEntrypointQuery,
} = exerciseEntrypointApi;
